/// <reference types="react/experimental" />
import * as React from 'react';
import { useMemo, useRef } from 'react';
import { mergeLatest } from 'retil-source';
import { useSource } from 'use-source';
var useTransition = React.unstable_useTransition;
export var useRouterSourceConcurrent = function (source, options) {
    if (options === void 0) { options = {}; }
    var _a = useTransition(), startTransition = _a[0], pending = _a[1];
    var latestSource = useMemo(function () {
        return mergeLatest(source, function (latestSnapshot, isSuspended) { return [latestSnapshot, isSuspended]; });
    }, [source]);
    var lastSnapshot = useRef(null);
    var _b = useSource(latestSource, {
        defaultValue: null,
        startTransition: startTransition,
    }) || [null, false], currentSnapshot = _b[0], isSuspended = _b[1];
    var snapshotPending = pending || (currentSnapshot ? isSuspended : !!lastSnapshot.current);
    var snapshot = currentSnapshot || lastSnapshot.current;
    // Changing routers isn't covered by a transition, and we don't want an
    // initially empty new router to trigger a loading screen, so we'll use
    // the last snapshot from the previous router until the first snapshot
    // is available.
    if (currentSnapshot) {
        lastSnapshot.current = currentSnapshot;
    }
    return [snapshot, snapshotPending];
};
